/** Parse and validate Cronyl card IDs from URL params or NFC links */

const CARD_ID_PATTERN = /^[a-z0-9_-]{4,32}$/i;

export function isValidCardId(id: string): boolean {
  return CARD_ID_PATTERN.test((id || '').trim());
}

/** Read ?id= from setup page URL */
export function getCardIdFromQuery(): string {
  const params = new URLSearchParams(window.location.search);
  return (params.get('id') || params.get('card') || '').trim();
}

/** Extract card ID from pay.cronyl.com/c/{id} paths */
export function parseCardIdFromInput(input: string): string | null {
  const trimmed = (input || '').trim();
  if (!trimmed) return null;

  if (isValidCardId(trimmed)) return trimmed;

  try {
    const url = trimmed.startsWith('http') ? new URL(trimmed) : new URL(trimmed, 'https://pay.cronyl.com');
    const match = url.pathname.match(/\/c\/([a-z0-9_-]{4,32})/i);
    if (match?.[1] && isValidCardId(match[1])) return match[1];
  } catch {
    /* not a URL */
  }

  return null;
}
